import React, { useState, useEffect } from 'react';
import {
  Input,
  InputGroup,
  Table,
  Stack,
  Breadcrumb,
  Divider,
  Container,
  Panel,
  Toggle,
  toaster,
  Message
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;
const Setting = () => {
  const [categorydata, setCategorydata] = useState([]);
  const [products, setProducts] = useState([]);
  const [catloading, setCatloading] = useState(false);
  useEffect(() => {
    fetchData();
    fetchDatap();
  }, []);

  const fetchData = async () => {
    setCatloading(true);
    const response = await fetch(
      `${globalIP}/api/mstcategories?populate=*&sort[0]=id&publicationState=preview&pagination[page]=1`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstcategories?populate=*&sort[0]=id&publicationState=preview&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setCategorydata(allData);
    setCatloading(false);
  };
  const fetchDatap = async () => {
    const response = await fetch(
      `${globalIP}/api/products?populate=*&sort[0]=id&publicationState=preview`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/products?populate=*&sort[0]=id&publicationState=preview&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setProducts(allData);
  };

  const updateProductPublishedAt = async (categoryCode, isChecked) => {
    const updatedProducts = products.map(product => {
      if (product.attributes.CategoryCode === categoryCode) {
        return {
          ...product,
          attributes: {
            ...product.attributes,
            publishedAt: isChecked ? new Date().toISOString() : null // Set today's date or null based on checkbox status
          }
        };
      }
      return product;
    });

    const updatedmaster = categorydata.map(category => {
      if (category.attributes.CategoryCode === categoryCode) {
        return {
          ...category,
          attributes: {
            ...category.attributes,
            publishedAt: isChecked ? new Date().toISOString() : null // Set today's date or null based on checkbox status
          }
        };
      }
      return category;
    });

    updatedProducts.forEach(async product => {
      if (product.attributes.CategoryCode === categoryCode) {
        try {
          const response = await fetch(`${globalIP}/api/products/${product.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                publishedAt: product.attributes.publishedAt // Update with today's date or null
              }
            })
          });

          if (!response.ok) {
            console.error('Failed to update product:', product.id);
          } else {
            console.log(`Product ${product.id} updated successfully`);
          }
        } catch (error) {
          console.error('Error updating product:', error);
        }
      }
    });
    updatedmaster.forEach(async category => {
      if (category.attributes.CategoryCode === categoryCode) {
        try {
          const response = await fetch(`${globalIP}/api/mstcategories/${category.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                publishedAt: category.attributes.publishedAt // Update with today's date or null
              }
            })
          });
          if (!response.ok) {
            console.error('Failed to update product:', category.id);
          } else {
            console.log(`Product ${category.id} updated successfully`);
          }
        } catch (error) {
          console.error('Error updating product:', error);
        }
      }
    });
    setProducts(updatedProducts);
    setCategorydata(updatedmaster);
  };
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = value => {
    setSearchQuery(value);
  };

  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">All Settings</h3>
              <Breadcrumb>
                <Breadcrumb.Item href={`${ugr}/dashboard`}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Settings</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>

          <Stack direction="column" alignItems="flex-end" spacing={24}>
            <Stack spacing={5}>
              <InputGroup inside>
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: 0, marginBottom: 0 }} />
        <Panel>
          <Table
            height={400}
            data={categorydata.filter(item => {
              const category = item.attributes.CategoryName
                ? item.attributes.CategoryName.toLowerCase()
                : '';
              const query = searchQuery.toLowerCase();
              return category.includes(query);
            })}
            loading={catloading}
          >
            <Column width={150} align="center">
              <HeaderCell>
                <b>Category</b>
              </HeaderCell>
              <Cell dataKey="attributes.CategoryName" />
            </Column>
            <Column width={100} align="center">
              <HeaderCell>
                <b>Access</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const matchingProducts = products.filter(
                    product => product.attributes.CategoryCode === rowData.attributes.CategoryCode
                  );

                  let isChecked = false;

                  if (matchingProducts.length === 0) {
                    // No products found for the given CategoryCode
                    console.log(
                      `No products found for CategoryCode: ${rowData.attributes.CategoryCode}`
                    );
                    isChecked = true && rowData.attributes.publishedAt; // Set isChecked to true if no matching products
                  } else {
                    // Check if any of the matching products are published
                    isChecked = matchingProducts.some(product => product.attributes.publishedAt);
                  }

                  // Now isChecked will be true if no matching products were found,
                  // or if at least one matching product is published.

                  // const isChecked = products.some(
                  //   product =>
                  //     product.attributes.CategoryCode === rowData.attributes.CategoryCode &&
                  //     product.attributes.publishedAt
                  // );
                  // console.log('isChecked');
                  // console.log(isChecked);
                  // isChecked = isChecked && rowData.attributes.publishedAt

                  return (
                    <Toggle
                      checked={isChecked}
                      onChange={checked => {
                        // Check if there are products for the given category
                        const categoryProducts = products.filter(
                          product =>
                            product.attributes.CategoryCode === rowData.attributes.CategoryCode
                        );

                        console.log('checked');
                        console.log(checked);
                        if (categoryProducts.length === 0) {
                          // Show an alert if no products exist for the selected category
                          toaster.push(
                            <Message showIcon type="error">
                              No products found for this category.
                            </Message>,
                            { placement: 'topCenter' }
                          );
                          // return;
                        }

                        // Proceed with updating the category and products
                        updateProductPublishedAt(rowData.attributes.CategoryCode, checked);
                      }}
                    />
                  );
                }}
              </Cell>
            </Column>
          </Table>
        </Panel>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default Setting;
